module.exports = __webpack_public_path__ + "armenia.svg?400cb965e1f708a255d2d17bdc19a1e9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/armenia.svg
// module id = 95
// module chunks = 10